<template>
  <a-layout class="dict-content">
    <a-layout-sider width="280" style="background: #fff;padding:16px 0 16px 16px">
      <dict-tree ref="dictTreeDom" @formTitle="addDictEvent" @formNavTitle="editDictEvent"></dict-tree>
    </a-layout-sider>
    <a-layout-content style="background: #fff;padding: 16px">
      <div class="content">
        <form-input ref="formInput" @submitEvent="handleSubmit" :params="formIptTitle"></form-input>
      </div>
    </a-layout-content>
  </a-layout>
</template>

<script>
import DictTree from './modules/DictTree.vue'
import formInput from './modules/FormInput.vue'

export default {
  components: {
    DictTree, formInput
  },
  data () {
    return {
      formIptTitle: {
        formTitle: '字典详情'
      }
    }
  },
  methods: {
    addDictEvent () {
      this.formIptTitle.formTitle = '新建字典'
    },
    editDictEvent () {
      this.formIptTitle.formTitle = '编辑字典'
    },
    handleSubmit () {
      // 表单提交成功后,重新获取树的数据
      this.$refs['dictTreeDom'].queryDictData(true)
    }
  }
}
</script>
